import { useEffect, useState } from "react";
import { Layout } from "../../../ui/layout";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { AssignmentUpdate, DownloadAssignmentLetter, fileAssignSignedValidation, GetAssignmentById, resetAssigmentUpdateStatus, resetFileAssSignedValidationStatus, resetGetAssignmentByIdStatus, resetInspectionVisitCreationStatus, resetInspectionVisitRequest, resetUpdateFileSignedAssign, setAssignmentPMId, setAssignmentSignedFileId, setAssignmentUpdateRequest, setFileAssignSigned, UploadFileAssSigned } from "../slice";
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "../../../ui/icons/arrow-left";
import { normativa, optionsFormatter } from "../../../utils";
import { InspectionVisitList } from "../inspectionVisit/reducedList";
import { CustomHorizontalTab } from "../../../ui/organisms/customHorizontalTab";
import { InspectionVisitBioCostPrevision } from "../inspectionVisit/previsioneCosti";
import Button from "../../../ui/molecules/button";
import { Alert } from "../../../ui/organisms/alert";
import { PopupForm } from "../../../ui/organisms/popupForm";
import { FileInputComponent } from "../../../ui/molecules/fileInput";
import { RoundedPlusIcon } from "../../../ui/icons/RoundedPlusIcon";
import { InspectionVisitProdIntegrataAddPopup } from "../inspectionVisit/addProdIntegrata/popup";
import { InspectionVisitAddPopup } from "../inspectionVisit/addBiologico/popup";
import { InspectionVisitGGAddPopup } from "../inspectionVisit/addGlobalGap/popup";
import { FileViewer } from "../../../ui/molecules/fileViewer";
import { GetFileById, resetGetFileByIdStatus } from "../../../objectStorage/slice";
import { assignmentLetterTypeEnum } from "../dataservice/dto";

export function EditAssignment() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const assignmentState = useAppSelector(state => state.assignment)
    const usersState = useAppSelector(state => state.users)
    const objectStorageState = useAppSelector(state => state.objectStorage)
    const [showPopupAdd, setShowPopupAdd] = useState<boolean>(false)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const [showSuccessUploadFile, setShowSuccessUploadFile] = useState<boolean>(false)
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const [showAlertAccept, setShowAlertAccept] = useState<boolean>(false)
    const [showAssignFirmedPopup, setShowAssignFirmedPopup] = useState<boolean>(false)
    const [contractType, setContractType] = useState<assignmentLetterTypeEnum>(assignmentLetterTypeEnum.C08);

    let formData = new FormData()

    useEffect(() => {
        if (assignmentState.getAssignmentByIdStatus === 'successfully' &&
            assignmentState.getAssignmentByIdResponse !== undefined
        ) {
            const ass = assignmentState.getAssignmentByIdResponse
            const ref = assignmentState.getAssignmentByIdResponse.reference;
            const found = Object.values(assignmentLetterTypeEnum).find(code => ref.includes(code));
            if (found) {
                setContractType(found);
            }
            dispatch(resetGetAssignmentByIdStatus())
            dispatch(setAssignmentPMId(ass.personalManagementId))
            if (ass.fileId) {
                dispatch(setAssignmentSignedFileId(ass.fileId))
                dispatch(GetFileById(ass.fileId.toString()))
            }
            dispatch(setAssignmentUpdateRequest({
                pmContractId: ass.pmContractId,
                reference: ass.reference,
                revocationProtocolId: ass.revocationProtocolId !== null ? ass.revocationProtocolId : undefined,
                state: ass.state,
                signedAssignmentLetterId: ass.signedAssignmentLetterId !== null ? ass.signedAssignmentLetterId : undefined
            }))
        }
    }, [assignmentState.getAssignmentByIdStatus])

    useEffect(() => {
        if (objectStorageState.getFileByIdStatus === 'successfully') {
            dispatch(resetGetFileByIdStatus())
        }
    }, [objectStorageState.getFileByIdStatus]);


    useEffect(() => {
        if (assignmentState.assignmentUpdateStatus === 'successfully') {
            dispatch(resetAssigmentUpdateStatus())
            dispatch(GetAssignmentById(assignmentState.assignmentIdToUpdate))
            setShowSuccess(true)
            setShowAlertAccept(false)
        }
    }, [assignmentState.assignmentUpdateStatus])

    useEffect(() => {
        if (assignmentState.inspectionVisitCreationStatus === 'successfully') {
            dispatch(resetInspectionVisitCreationStatus())
            setShowSuccess(true)
        }
    }, [assignmentState.inspectionVisitCreationStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    useEffect(() => {
        if (assignmentState.fileAssignSignedUploadStatus === 'successfully') {
            dispatch(resetUpdateFileSignedAssign())
            setShowSuccessUploadFile(true)
            setShowAssignFirmedPopup(false)
            setTimeout(() => {
                setShowSuccessUploadFile(false)
                dispatch(GetAssignmentById(assignmentState.assignmentIdToUpdate))
            }, 2500);
        }
    }, [assignmentState.fileAssignSignedUploadStatus])

    useEffect(() => {
        if (assignmentState.fileAssignSignedValidationStatus === 'successfully') {
            formData.delete('file')
            formData.append('file', assignmentState.fileAssignSigned!)
            formData.append('officerId', usersState.findMeResponse.id!)
            formData.append('fileName', assignmentState.fileAssignSigned?.name!)
            dispatch(UploadFileAssSigned({ body: formData, id: assignmentState.assignmentIdToUpdate }))
            dispatch(resetFileAssSignedValidationStatus())
        }
    }, [assignmentState.fileAssignSignedValidationStatus])

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Incarichi', 'Modifica incarico']}
            noPaddingLat
            headerLabel="Gestione Incarichi"
            headerIcon={
                <button style={{ paddingTop: '12px' }} onClick={() => {
                    navigate('/incarichi')
                }}>
                    <ArrowLeftIcon />
                </button>
            }
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end" style={{ justifyContent: 'end', gap: '16px' }}>
                    <Button
                        variant="solid"
                        color="orange"
                        size="sm"
                        iconPosition="left"
                        icon={<RoundedPlusIcon />}
                        label="Aggiungi Controllo"
                        onClick={() => setShowPopupAdd(true)}
                    />
                    {
                        assignmentState.getAssignmentByIdResponse?.isAccepted ? (
                            <span></span>
                        ) : (
                            <Button size={"sm"} iconPosition={"off"} variant={"solid"} label="Accetta Incarico" color={"orange"}
                                onClick={() => {
                                    setShowAlertAccept(true);
                                }}
                            />
                        )
                    }

                    <Button
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Invia incarico firmato"
                        color={"orange"}
                        onClick={() => {
                            setShowAssignFirmedPopup(true)
                        }}
                    />
                    <Button size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Stampa Lettera"
                        color={"orange"}
                        onClick={() => {
                            dispatch(
                                DownloadAssignmentLetter({
                                    id: assignmentState.assignmentIdToUpdate,
                                    infoType: contractType
                                })
                            )
                        }}
                    />
                </div>
            }
        >
            <div>
                {
                    (showSuccessUploadFile) &&
                    <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                        <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                            File inviato correttamente.
                        </span>
                    </div>
                }
                <CustomHorizontalTab
                    selectedIndex={selectedTab}
                    onTabClick={(index) => setSelectedTab(index)}
                >
                    <div>Lista</div>
                    <div>Previsione costi</div>
                </CustomHorizontalTab>
                {
                    (assignmentState.getAssignmentByIdResponse) &&

                    <div
                        className="text-left"
                        style={{ borderRadius: '8px', padding: '24px' }}
                    >
                        <div className="text-green-800 sectionSubTitle assignment-subtitle flex-1">
                            {`Protocollo incarico: ${assignmentState.getAssignmentByIdResponse?.departureProtocolInfo} - Tipologia contratto: ${assignmentState.getAssignmentByIdResponse?.pmContractType}`}
                            {` - Riferimento: ${assignmentState.getAssignmentByIdResponse?.reference} - Normativa: ${optionsFormatter(assignmentState.getAssignmentByIdResponse?.norm, normativa)}`}
                        </div>
                        <div className="text-green-700 assignment-subtitle flex-1">

                        </div>
                    </div>
                }
                {
                    showSuccess &&
                    <div className="gap-[8px] text-left" style={{ margin: '24px', borderRadius: '12px', backgroundColor: '#D1F5D9', borderColor: '#8AE59F', borderWidth: 2 }}>
                        <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                            Dati salvati correttamente.
                        </span>
                    </div>
                }

                <div className="fieldset bg-brandPrimary-200">
                    {
                        selectedTab === 0 &&
                        <InspectionVisitList />
                    }
                    {
                        selectedTab === 1 &&
                        <InspectionVisitBioCostPrevision />
                    }
                </div>
            </div>
            {
                (showAlertAccept) && (
                    <Alert title="Conferma operazione" close={() => setShowAlertAccept(false)} headerGreen={true}>
                        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="pb-3 mt-4">
                                <div>
                                    Stai accettando o rifiutando un incarico. Vuoi Proseguire? {assignmentState.assignmentIdToUpdate}

                                </div>

                            </div>
                            <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button
                                    variant="outline"
                                    color="dimgrey"
                                    iconPosition="off"
                                    label="Chiudi finestra"
                                    size="md"
                                    onClick={() => setShowAlertAccept(false)}
                                />
                                <div className="pl-8">
                                    <Button
                                        variant="solid"
                                        color={'green'}
                                        iconPosition="off"
                                        label={'Accetta'}
                                        size="md"
                                        onClick={() => {
                                            dispatch(AssignmentUpdate(
                                                { body: { isAccepted: true }, id: assignmentState.assignmentIdToUpdate })
                                            )
                                        }
                                        }
                                    />
                                </div>
                                <div className="pl-8">
                                    <Button
                                        variant="solid"
                                        color={'red'}
                                        iconPosition="off"
                                        label={'Rifiuta'}
                                        size="md"
                                        onClick={() => {
                                            dispatch(AssignmentUpdate(
                                                { body: { isAccepted: false }, id: assignmentState.assignmentIdToUpdate })
                                            )
                                        }
                                        }
                                    />
                                </div>
                            </div>

                        </div>
                    </Alert>
                )
            }

            {
                showPopupAdd &&
                <PopupForm title={`Inserimento dettagli all'incarico ${assignmentState.getAssignmentByIdResponse?.reference}`} headerGreen
                    close={() => {
                        setShowPopupAdd(false)
                        dispatch(resetInspectionVisitRequest())
                    }}>
                    {
                        assignmentState.getAssignmentByIdResponse?.norm === 'PRODUZIONE_INTEGRATA' && (
                            <InspectionVisitProdIntegrataAddPopup close={() => {
                                setShowPopupAdd(false)
                                dispatch(resetInspectionVisitRequest())
                            }} />
                        )
                    }
                    {
                        assignmentState.getAssignmentByIdResponse?.norm === 'NORMA_BIO' && (
                            <InspectionVisitAddPopup close={() => {
                                setShowPopupAdd(false)
                                dispatch(resetInspectionVisitRequest())
                            }} />
                        )
                    }
                    {
                        assignmentState.getAssignmentByIdResponse?.norm === 'GLOBAL_GAP' && (
                            <InspectionVisitGGAddPopup close={() => {
                                setShowPopupAdd(false)
                                dispatch(resetInspectionVisitRequest())
                            }} />
                        )
                    }

                </PopupForm>
            }

            {
                showAssignFirmedPopup && (
                    <PopupForm headerGreen={true} title="Invia Incarico Firmato" close={() => {
                        setShowAssignFirmedPopup(false)
                    }}>
                        <div style={{ padding: '24px' }}>
                            <div className=" pb-3 pt-3">
                                <span className="sectionTitle">Seleziona e invia incarico firmato</span>
                            </div>
                            <div style={{ width: '90%', margin: 'auto' }}>
                                <FileInputComponent
                                    id={"ep-edit-upload-add"}
                                    key={"ep-edit-upload-add"}
                                    infoText
                                    fullHeight
                                    color={"green"}
                                    onChange={(e) => {
                                        dispatch(setFileAssignSigned(e[0]))
                                    }}
                                />
                            </div>
                            <div className="mt-4">
                                <div style={{ width: '90%', margin: 'auto' }}>
                                    <div className="">
                                        <span className="sectionTitle">Visualizza incarico firmato</span>
                                    </div>
                                    {
                                        (assignmentState.assignedSignedFileId && objectStorageState.getFileByIdResponse) && (
                                            <div className="pt-3" style={{ display: 'flex', alignItems: 'center' }}>
                                                <FileViewer
                                                    fileId={assignmentState.assignedSignedFileId.toString()}
                                                    smallSize={true}
                                                    fileName={objectStorageState.getFileByIdResponse.name}
                                                    otherInfo={objectStorageState.getFileByIdResponse.data}
                                                />
                                            </div>

                                        )
                                    }
                                </div>

                            </div>
                            <div style={{ width: '90%', margin: 'auto' }} >
                                <div className="mt-6 flex align-right"  >
                                    <Button
                                        size={"sm"}
                                        iconPosition={"off"}
                                        variant={"solid"}
                                        label="Carica File"
                                        color={"green"}
                                        onClick={() => {
                                            dispatch(fileAssignSignedValidation({
                                                file: assignmentState.fileAssignSigned!
                                            }))
                                        }}
                                    />
                                </div>

                            </div>
                        </div>

                    </PopupForm>
                )
            }

        </Layout>
    )
}